import React from 'react';
import { AlertTriangle, TrendingDown, RefreshCw, CheckCircle } from 'lucide-react';
import type { DashboardAlert } from '../../services/api';

interface AlertsPanelProps {
  alerts: DashboardAlert[];
}

const SEVERITY_STYLES: Record<string, { border: string; bg: string; text: string }> = {
  red: { border: 'border-red-500', bg: 'bg-red-50', text: 'text-red-700' },
  orange: { border: 'border-orange-500', bg: 'bg-orange-50', text: 'text-orange-700' },
  yellow: { border: 'border-yellow-500', bg: 'bg-yellow-50', text: 'text-yellow-700' },
};

const getIcon = (type: string) => {
  switch (type) {
    case 'revenue_decline': return <TrendingDown size={14} />;
    case 'high_refund_rate': return <AlertTriangle size={14} />;
    case 'sync_stale': return <RefreshCw size={14} />;
    default: return <AlertTriangle size={14} />;
  }
};

export const AlertsPanel: React.FC<AlertsPanelProps> = ({ alerts }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h3 className="text-base font-semibold text-gray-900 mb-3">Alerts & Concerns</h3>
      {alerts.length === 0 ? (
        <div className="flex items-center gap-2 text-emerald-600 py-4">
          <CheckCircle size={18} />
          <span className="text-sm font-medium">All systems healthy</span>
        </div>
      ) : (
        <div className="space-y-2">
          {alerts.map((alert, i) => {
            const style = SEVERITY_STYLES[alert.severity] || SEVERITY_STYLES.yellow;
            return (
              <div
                key={i}
                className={`border-l-4 ${style.border} ${style.bg} rounded-r-lg px-3 py-2.5 flex items-center gap-2`}
              >
                <span className={style.text}>{getIcon(alert.type)}</span>
                <span className={`text-sm ${style.text}`}>{alert.message}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
